export { ApprovedReviewsPage as default } from '@admin-web/module/approvedReviews'
